import { useState, useEffect } from "react";

function AdminOffer() {
  const [text, setText] = useState("");
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    setText(localStorage.getItem("offer_text") || "");
    setEnabled(localStorage.getItem("offer_enabled") === "true");
  }, []);

  const save = () => {
    localStorage.setItem("offer_text", text);
    localStorage.setItem("offer_enabled", enabled);
    alert("Saved!");
  };

  return (
    <div className="page" style={{ maxWidth: "600px", margin: "auto" }}>
      <h1>Offer Control Panel</h1>

      <label>Offer Text:</label>
      <input
        value={text}
        onChange={(e) => setText(e.target.value)}
        style={{ width: "100%", padding: "10px", margin: "10px 0" }}
      />

      <label>
        <input
          type="checkbox"
          checked={enabled}
          onChange={() => setEnabled(!enabled)}
        />
        Enable Popup
      </label>

      <br /><br />

      <button onClick={save}>
        Save Changes
      </button>
    </div>
  );
}

export default AdminOffer;